export default "__VITE_ASSET__CpNWBmVm__"